import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Body from 'storybookConfig/stories/molecules/Body';

const ProgressBarContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const ProgressBarHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StepLabel = styled.span`
  color: ${({ theme }) => theme.color.bodyTextSecondary};

  &::before {
    content: ' · ';
  }
`;

interface ProgressBarStepProps {
  isCompleted: boolean;
}

export const ProgressBarStep = styled.div<ProgressBarStepProps>`
  border-radius: 10px;
  min-width: 32px;
  height: 8px;

  ${({ theme, isCompleted }) => css`
    background-color: ${isCompleted ? theme.color.accent : theme.color.surfaceStrong};
  `}
`;

export interface ProgressBarProps {
  totalSteps: number;
  completedSteps: number;
  stepLabel?: string;
}

const ProgressBar = ({ totalSteps, completedSteps, stepLabel }: ProgressBarProps) => (
  <ProgressBarHeader>
    <Body variant="Body/Header" color="bodyTextSecondary">
      Step {completedSteps} of {totalSteps}
      {stepLabel && <StepLabel>{stepLabel}</StepLabel>}
    </Body>

    <ProgressBarContainer>
      {[...Array(totalSteps)].map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <ProgressBarStep key={`step-${i}`} isCompleted={i < completedSteps} />
      ))}
    </ProgressBarContainer>
  </ProgressBarHeader>
);

export default ProgressBar;
